module.exports = __webpack_public_path__ + "img/4-(10).212281f7.jpg";